<template>
  <div>
    <vs-popup :title=" (base.item === '' ? 'AJOUTER' : 'MODIFIER') + ' UN PAYS'" :active.sync="base.addOrUpdateItem">
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <div class="container">
          <div class="row justify-content-md-center">
            <div>
              <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                Libelle
              </vs-col>

              <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                Indicatif
              </vs-col>
              
              <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vs-input @keyup.enter="submitData" v-model="input.name" class="w-full" name="name" />
              </vs-col>

              <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vs-input @keyup.enter="submitData" v-model="input.indicatif" class="w-full" name="indicatif" />
              </vs-col>

              <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button class="mr-6" color="white"></vs-button>
              </vs-col>
              <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button class="mr-6" color="white"></vs-button>
              </vs-col>
              <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button class="mr-6" color="white"></vs-button>
              </vs-col>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
      
      <vs-divider style="height: 2px" background="primary"></vs-divider>
      <div class="flex flex-wrap items-center">
        <vs-button class="mr-6" @click="submitData">Valider</vs-button>
        <vs-button type="border" color="danger" @click="base.addOrUpdateItem = false">Annuler</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
var base_self
var input_tempon = {
  name: '',
  indicatif: '',
}
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  props: {
    base: ''
  },
  components: {
    VuePerfectScrollbar,
    Datepicker
  },
  watch: {
  },
  data() {
    return {
      url: '/countries',
      input: {},
      language: "fr",
      languages: lang,
      settings: {
        maxScrollbarLength: 600,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
  },
  methods: {
    mountedFounction () {
      base_self.inputInitialize()
    },
    initInput () {
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
    },
    inputInitialize () {
      (base_self.base.item !== '') ? (base_self.input = JSON.parse(JSON.stringify(base_self.base.item))) : base_self.initInput()  
    },
    submitData() {
      var input = JSON.parse(JSON.stringify(base_self.input))
      base_self.$vs.loading()
      // console.log('input: ', input);
      
      if (!base_self.base.item && !input.id) {
        base_self.$http.post(base_self.url, input)
        .then((response) => { window.getApp.success("Le pays a été ajouté avec succès.", response); base_self.initInput(); base_self.base.addOrUpdateItem = false; base_self.base.getList() })
        .catch((error) => { window.getApp.error(error) })
      } else {
        base_self.$http.put(base_self.url + `/${input.slug}`, input)
        .then((response) => { window.getApp.success("Le pays a été modifié avec succès.", response); base_self.initInput(); base_self.base.addOrUpdateItem = false; base_self.base.getList() })
        .catch((error) => { window.getApp.error(error) })
      }
    }
  },
  created() {
    base_self = this
  },
  mounted() {
    base_self.base.ajoutComponent = base_self
    base_self.mountedFounction()
  }
};
</script>

<style>
  .kijinput {
    padding: 5px;
    /* padding-left: 15px; */
  }
  .kijinput {
    padding: 5px;
    /* padding-right: 15px; */
  }
</style>